import { render, staticRenderFns } from "./chillingcenter.vue?vue&type=template&id=54237dd1&"
import script from "./chillingcenter.vue?vue&type=script&lang=js&"
export * from "./chillingcenter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports